import { get } from '../index';

export const getAffiliationsAdmin = () => {
  return get(`/affiliation`);
};
